const FocusSet = () => {
  const init = () => {
    const triggers = document.querySelectorAll(".js-focus-set[data-focus]");

    const moveFocus = (event) => {
      const trigger = event.currentTarget;
      if (trigger.getAttribute("aria-expanded") !== "true") return;

      const selector = trigger.getAttribute("data-focus");
      if (!selector) return;

      const target = document.querySelector(selector);
      if (!target) return;

      requestAnimationFrame(() => target.focus());
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", moveFocus);
    });
  };

  return { init };
};
export default FocusSet;
